import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import Moment from "react-moment";

class ConfirmationModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired,
        onConfirm: PropTypes.func,
        onCancel: PropTypes.func,
        children: PropTypes.node.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {onConfirm, onCancel, onHide, children, ...props} = this.props;
        return (
            <Modal {...props} className="modal-alert modal-warning" bsSize="small">
                <Modal.Header>
                    <i className="fa fa-question-circle"/>
                </Modal.Header>
                <Modal.Body>
                    {children}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success"
                            onClick={() => { if (onConfirm) onConfirm(); onHide(); }}>
                        Да
                    </button>
                    <button type="button" className="btn"
                            onClick={() => { if (onCancel) onCancel(); onHide(); }}>
                        Нет
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/modals/ConfirmationModal.js